import React from 'react'
import { RadioButton } from '@mobi/component-library/Selection&Input/RadioButton'
import { BetCard } from '@mobi/betslip/Components/Common/BetCard'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'
import { formatKambiCurrencyToDollarDecimal } from '@core/Areas/KambiSports/helpers/currencyFormat'
import { getEventLink } from '@core/Areas/KambiSports/helpers/navigation'
import { SportsIcon } from '@core/Areas/KambiSports/Components/Common/SportsIcon'
import { TeamIcon } from '@core/Areas/KambiSports/Components/BetHistory/BetInfo/Components//Common/TeamsIcon'
import { KambiHistoryCouponDisplayContext } from '@core/Areas/KambiSports/Components/BetHistory/context'
import { CountdownStatus } from '../Common/CountdownStatus'
import { LegStatusIcon } from '../Common/LegStatusIcon'

export const Single: React.FC<{
  event: BetLoopKambiShareCoupon['events'][0]
  outcome: BetLoopKambiShareCoupon['outcomes'][0]
  betOffers: BetLoopKambiShareCoupon['betOffers']
  playedOdds: BetLoopKambiShareCoupon['couponRows'][0]['playedOdds']
  betStatus:
    | BetLoopKambiShareCoupon['bets'][0]['betStatus']
    | BetLoopKambiShareCoupon['couponRows'][0]['status']
  isWithinMultiBet?: boolean
  /** Used for quick share of single bet to Bet Loop */
  betRef?: BetLoopKambiShareCoupon['bets'][0]['betRef']
  onMultiLegCountdownReachingZero?(): void
}> = ({
  event,
  outcome,
  betOffers,
  playedOdds,
  betStatus,
  isWithinMultiBet,
  betRef,
  onMultiLegCountdownReachingZero,
}) => {
  const couponDisplayContext = React.useContext(KambiHistoryCouponDisplayContext)

  const isBetLoopQuickShare = couponDisplayContext.type === 'betloop-quick-share'
  const shouldDisplayQuickShareToggle = !isWithinMultiBet && isBetLoopQuickShare && betRef

  const { eventName, eventStartDate, eventId, sport } = event
  const heading = outcome.label
  const subHeading = betOffers[0].criterion
  const sportName = event.sport
  const leagueId = event.eventGroups?.[event.eventGroups.length - 1]?.id
  const participationId = outcome.participantId

  return (
    <>
      <BetCard.EventDetails
        heading={eventName}
        iconComponent={<SportsIcon sport={sport} />}
        statusComponent={
          <>
            {(isWithinMultiBet && outcome.status === 'OPEN') || !isWithinMultiBet ? (
              <CountdownStatus
                displayType={isWithinMultiBet ? 'multi-leg' : 'standard'}
                eventStartTime={eventStartDate}
                betStatus={betStatus}
                onCountdownReachingZero={onMultiLegCountdownReachingZero}
              />
            ) : null}

            {shouldDisplayQuickShareToggle && (
              <RadioButton
                size='md'
                type='Tick'
                id={betRef.toString()}
                isChecked={couponDisplayContext.data.isSelected}
              />
            )}
          </>
        }
      />

      <BetCard.SelectionInfo
        heading={heading}
        subHeading={subHeading}
        priceWin={playedOdds && formatKambiCurrencyToDollarDecimal(playedOdds)}
        linkInfo={{ pathname: getEventLink(eventId) }}
        rightAlignedComponent={isWithinMultiBet && <LegStatusIcon status={outcome.status} />}
        iconComponent={
          <TeamIcon
            leagueId={leagueId}
            participationId={participationId}
            defaultIcon={<SportsIcon sport={sportName} size='2rem' />}
            size='2rem'
          />
        }
      />
    </>
  )
}
